import { UserType } from "@/constants";

export const HERA_COURT_LINK_ZIP_HREF =
  "/court-link-helper/hera-court-link.zip";
export const HERA_COURT_LINK_USERSCRIPT_HREF =
  "/court-link-helper/hera-court-link.user.js";
export const HERA_COURT_LINK_PUBLIC_INSTALL_HREF = "/court-link-helper/";

export function chromeWebStoreUrlFromEnv(raw: unknown): string | null {
  if (typeof raw !== "string") {
    return null;
  }
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** Chrome Web Store listing URL when the extension is published unlisted/private. */
export function getHeraCourtLinkChromeWebStoreUrl(): string | null {
  return chromeWebStoreUrlFromEnv(
    import.meta.env.VITE_HERA_COURT_LINK_CHROME_WEB_STORE_URL,
  );
}

export function getBrowserExtensionsSetupHref(userType: UserType): string {
  if (userType === UserType.GOVERNMENT) {
    return "/government/setup?tab=extensions";
  }
  return "/operator/setup?tab=extensions";
}
